import {
    GET_ACTIVE_PROMO_EVENT,
    GET_ACTIVE_PROMO_EVENT_SUCCESS,
  } from "./actionTypes"
  
  export const getActivePromoEvent = () => {
    return {
      type: GET_ACTIVE_PROMO_EVENT,
      payload: {  },
    }
  }
  
  export const getActivePromoEventSuccess = (response) => {
    return {
      type: GET_ACTIVE_PROMO_EVENT_SUCCESS,
      payload: response,
    }
  }
  